import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { StaticMessage } from '@shared/enums';
import { ClientSupport } from '@shared/models';
import {
  ClientSupportService,
  ToastNotificationService,
} from '@shared/services';
import { FileService } from '@shared/services/files';
import { Constants, getStaticMessage } from '@shared/utils';
import { ConfirmDialogComponent } from '..';
import { tap } from 'rxjs';

@Component({
  selector: 'app-client-support',
  templateUrl: './client-support.component.html',
  styleUrls: ['./client-support.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientSupportComponent {
  @Input({ required: true }) clientSupport: ClientSupport;
  @Input({ required: true }) isAppOnline: boolean;

  constructor(
    private fileService: FileService,
    private toastNotificationService: ToastNotificationService,
    private dialog: MatDialog,
    private clientSupportService: ClientSupportService
  ) {}

  openContactInfo(): void {
    if (!this.clientSupport?.contactInfo) {
      console.log('Contact information is not defined');
      this.toastNotificationService.error(
        $localize`:@@shared.clientSupport.txtContactInformationError:Error displaying contact information`
      );

      return;
    }

    this.dialog.open(ConfirmDialogComponent, {
      ...Constants.DialogOptions,
      disableClose: false,
      data: {
        title: $localize`:@@shared.clientSupport.titleContactInformation:Contact Information`,
        message: this.clientSupport.contactInfo,
        buttonLabel: getStaticMessage(StaticMessage.CloseButton),
        hideCancelButton: true,
        displayCloseButton: true,
      },
    });
  }

  downloadUserManual(): void {
    this.clientSupportService
      .getUserManualDetails(this.clientSupport?.clientId)
      .pipe(
        tap((manual) => {
          if (!manual?.externalUrl) {
            this.toastNotificationService.error(
              $localize`:@@shared.clientSupport.txtErrorDownloadingMissingUserManual:No user manual exists for client`
            );
            return;
          }
          this.fileService.download(
            manual.externalUrl,
            manual.name,
            manual.type
          );
        })
      )
      .subscribe();
  }
}
